"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCarport64 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h64v64H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M16 49V20.8L48 15m-.278 29.31v3.142c0 .578-.525 1.046-1.172 1.046h-3.517c-.648 0-1.173-.468-1.173-1.046V44.31m-16.412 0v3.14c0 .579-.525 1.047-1.173 1.047h-3.517c-.647 0-1.172-.468-1.172-1.046V44.31M22 40.093h4.42m14.556 0h4.42m2.326-4.4-4.382-9.047c-.185-.39-.605-.644-1.07-.646H25.038c-.464.002-.884.255-1.07.646l-4.38 9.048v8.617h28.135v-8.617Zm-28.136.15h28.136", stroke: "currentColor" })] })) }))); };
exports.default = SvgCarport64;
